import validators from '../utils/validators';

class DiagnosesEstablishment {
  /**
   * @param data
   */
  constructor(data) {
    const properties = {
      id: (v) => validators.isNotEmptyString(v),
      diagnosis: (v) => validators.isNotEmptyString(v),
      type: (v) => validators.isStringOrNull(v),
      user: (v) => validators.isNotEmptyString(v),
      note: (v) => validators.isStringOrNull(v),
      dateFrom: (v) => validators.isString(v),
      dateTo: (v) => validators.isStringOrNull(v),
      createdBy: (v) => validators.isStringOrNull(v),
    };

    for (const property of Object.keys(properties)) {
      if (properties[property](data[property]) !== true) {
        throw new Error(`Invalid property ${property} in ${data.id}`);
      }

      if (['dateFrom', 'dateTo'].includes(property)) {
        if (typeof data[property] === 'string' && data[property].trim() !== '') {
          this[property] = new Date(data[property]);
        }
      } else {
        this[property] = data[property];
      }
    }
  }
}

export default DiagnosesEstablishment;
